// extracted by mini-css-extract-plugin
export default {"left-panel":"RevisionsModal_left-panel__JhubF","track":"RevisionsModal_track__oUmBY"};